import React from 'react';
import PropTypes from 'prop-types';

class StartupNameGenerator extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    generate: PropTypes.func.isRequired,
  }

  onClick() {
    this.props.generate();
  }

  render() {
    return (
      <div>
        <button onClick={() => this.onClick()}>
          make me another!
        </button>
        &nbsp;&nbsp;{this.props.name}
      </div>
    );
  }
}

export default StartupNameGenerator;



// WEBPACK FOOTER //
// src/components/StartupNameGenerator/StartupNameGenerator.js